/* istanbul ignore file */

import useMediaQuery from './useMediaQuery';

export { default as breakpoints } from '@constants/breakpoints';

export default useMediaQuery;
